import moment from "moment";
import LocalizedStrings from "react-localization";
import { Button, Card, Flex, Grid, Text } from "@aws-amplify/ui-react";
import AlertIcon from "@mui/icons-material/NotificationImportant";
import { CTooltip } from "@coreui/react";

import { globalStrings } from "config/translations/es";
import usePermissions from "hooks/usePermission";

const AlertCard = ({ item, onRecognize }) => {
  const canRecognize = usePermissions("alert:recognize");
  return (
    <Card height="fit-content" borderRadius="medium" variation="outlined">
      <Grid
        className="m-3"
        templateColumns={{
          medium: `3fr 2fr`,
        }}
      >
        <Grid
          gap={20}
          templateColumns={{
            medium: `${item.status === "1" ? "0fr" : ""} 1fr`,
          }}
        >
          {item.status === "1" && (
            <CTooltip
              content={
                <div>
                  <p>
                    {item.name} /{" "}
                    {globalStrings.severity.options[item.severity]}
                  </p>
                  <p style={{ marginBottom: 0 }}>{item.description}</p>
                </div>
              }
            >
              <div style={{ alignSelf: "center" }}>
                <AlertIcon
                  style={styles.alertIcon}
                  htmlColor={item.severityColor ?? "#000000"}
                />
              </div>
            </CTooltip>
          )}
          <Flex>
            <div>
              <Text variation="primary" as="p" fontWeight={500}>
                {item.name} / {globalStrings.severity.options[item.severity]}
              </Text>
              <Text variation="tertiary" as="p">
                {item.companyName} - {item.branchName} - {item.deviceName}
              </Text>
            </div>
          </Flex>
        </Grid>
        <Grid
          gap={20}
          templateColumns={{
            medium: `2fr 1fr`,
          }}
        >
          <div>
            <Text variation="tertiary" as="p">
              {strings.activatedAt}:{" "}
              {moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
            </Text>
            {item.recognizedAt && (
              <Text variation="tertiary" as="p">
                {strings.recognizedAt}:{" "}
                {moment(item.recognizedAt).format("YYYY-MM-DD HH:mm:ss")}
              </Text>
            )}
            {item.recognizedByUser && (
              <Text variation="tertiary" as="p">
                {strings.recognizedByUser}: {item.recognizedByUser}
              </Text>
            )}
          </div>
          {item.status === "1" && canRecognize && (
            <Button
              style={styles.buttonRecognize}
              children={strings.recognize}
              onClick={() => onRecognize(item.id)}
            ></Button>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

const strings = new LocalizedStrings({
  es: {
    recognize: "Reconocer",
    activatedAt: "Fecha activado",
    recognizedAt: "Fecha reconocido",
    recognizedByUser: "Reconocido por",
  },
});

const styles = {
  buttonRecognize: {
    justifySelf: "flex-end",
    width: "fit-content",
    height: "fit-content",
  },
  alertIcon: {
    fontSize: "30px",
  },
};

export default AlertCard;
